// users Slice
import courseSlice from './courseSlice/courseSlice';
import courseSlicebyId from './courseSlice/courseSlicebyId';
import exerciseSlice from './exerciseSlice/exerciseSlice';
import userSlice from './users/userSlice';

const rootSlice = {
  users: userSlice,
  course: courseSlice,
  coursebyId: courseSlicebyId,
  exercises: exerciseSlice
};

export default rootSlice;
